import { Stack } from '@mui/material'
import { type FC } from 'react'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'
import { SearchesFilterBuilder } from './CandidateMinimalFilters'
import { ProcessStatusFilterSection } from './ProcessStatusFilterSection'

interface SearchesFilterSectionProps {
    filters: CandidateFilterState
    updateFilters: (patch: Partial<CandidateFilterState>) => void
}

export const SearchesFilterSection: FC<SearchesFilterSectionProps> = ({
    filters,
    updateFilters,
}) => {
    return (
        <Stack gap={2.5} sx={{ p: 2 }}>
            <SearchesFilterBuilder
                searchFilters={filters.searchFilters}
                onChange={(searchFilters) => updateFilters({ searchFilters })}
            />
            <ProcessStatusFilterSection
                filters={filters}
                updateFilters={updateFilters}
            />
        </Stack>
    )
}
